import type { ActionButtonOption } from "../ActionButtons";
import type { SelectedActionButtonOption } from "../SelectedActions";
import { $t } from "@/services/i18n";

export function refreshButton(
  handler: () => void,
  options: Partial<ActionButtonOption> = {}
): ActionButtonOption {
  return {
    handler,
    icon: "lucide:refresh-ccw",
    shape: "circle",
    variant: "outline",
    tooltip: $t("refresh"),
    ...options,
  };
}

export function removeSelectedButton<T>(
  handler: (selectedItems: T[]) => void,
  options: Partial<SelectedActionButtonOption> = {}
): SelectedActionButtonOption {
  return {
    handler,
    icon: "lucide:trash-2",
    variant: "light",
    label: $t("remove"),
    color: "red",
    ...options,
  };
}

export function deactivateSelectedButton<T>(
  handler: (selectedItems: T[]) => void,
  options: Partial<SelectedActionButtonOption> = {}
): SelectedActionButtonOption {
  return {
    handler,
    // icon: "lucide:pause",
    variant: "filled",
    label: $t("deactivate"),
    ...options,
  };
}

export function activateSelectedButton<T>(
  handler: (selectedItems: T[]) => void,
  options: Partial<SelectedActionButtonOption> = {}
): SelectedActionButtonOption {
  return {
    handler,
    // icon: "lucide:play",
    variant: "filled",
    label: $t("activate"),
    ...options,
  };
}
